import script from "./EncuestaResultadosModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EncuestaResultadosModal.vue?vue&type=script&setup=true&lang=ts"

import "./EncuestaResultadosModal.vue?vue&type=style&index=0&id=0f16e163&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f16e163"]])

export default __exports__